export const IS_APP_BANNER_DISMISSED_KEY = 'isAppBannerDismissed';
export const IS_PT1_APP_BANNER_DISMISSED_KEY = 'isPT1AppBannerDismissed';
